import React from 'react'
import { OTPVerificationFailedCase as OTPFailedCase } from '../../types/otp.types'

interface OTPErrorMessageProps {
  hasError: boolean
  OTPVerificationFailedCase: OTPFailedCase | null
  otpErrorMessage?: string
}

export const OTPErrorMessage: React.FC<OTPErrorMessageProps> = ({
  hasError,
  OTPVerificationFailedCase,
  otpErrorMessage
}) => {
  const getErrorMessage = () => {
    if (otpErrorMessage) return otpErrorMessage
    if (!hasError || !OTPVerificationFailedCase) return null

    switch (OTPVerificationFailedCase) {
      case OTPFailedCase.INVALID_OTP:
        return 'Incorrect OTP. Please try again.'
      case OTPFailedCase.OTP_EXPIRED:
        return 'OTP has expired. Please request a new one.'
      case OTPFailedCase.OTP_VERIFICATION_FAILED:
        return 'Verification failed. Please try again.'
      default:
        return 'Incorrect OTP. Please try again'
    }
  }

  const errorMessage = getErrorMessage()

  if (!errorMessage) return null

  return (
    <div className='text-left mb-4'>
      <p className='text-[#CC5C2D] text-[14px] font-[500]'>{errorMessage}</p>
    </div>
  )
}
